import { render, staticRenderFns } from "./EditNotificationRecipient.vue?vue&type=template&id=69f4abbd"
import script from "./EditNotificationRecipient.vue?vue&type=script&lang=ts"
export * from "./EditNotificationRecipient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports